import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { buildPlanRecommendationRequestBody } from './build-plan-recommendation-request-body';
export const getPlanRecommendationTierQueryFn = async props => {
  const {
    httpClient,
    request: {
      siteGuid,
      p3Context,
      isMobile
    }
  } = props;
  const {
    getProductCardList
  } = PremiumPurchasePlatformModule.SDK.ApiClient.queries({
    httpClient
  });
  const catalog = await getProductCardList(p3Context);
  const body = buildPlanRecommendationRequestBody(catalog, siteGuid);
  if (!body) {
    throw new Error('No recommendable product to request a plan recommendation');
  }
  try {
    const response = await httpClient.post('/_api/premium-package-pickers-api/get-plan-recommendation', {
      ...body,
      skipLlm: true,
      ...(isMobile ? {
        isMobile: true
      } : {})
    });
    return response.data;
  } catch {
    return {
      bullets: [],
      siteName: '',
      recommendedProductId: body.recommendedProductIdFallback,
      recommendedProductName: body.recommendedProductNameFallback,
      isFallback: true
    };
  }
};
//# sourceMappingURL=get-plan-recommendation-tier.query.js.map